import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "labels" }
const _hoisted_2 = { class: "outline" }
const _hoisted_3 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cross_icon = _resolveComponent("cross-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1)
    ]),
    (_ctx.active && !_ctx.hideDiscardButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "discard",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args))),
          title: "Discard Metric"
        }, [
          _createVNode(_component_cross_icon, {
            style: {"margin-top":"4px"},
            height: 18,
            width: 18,
            iconColor: "var(--darkgrey)"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}